import { Injectable } from '@angular/core';
import { CompanyInsightApiIndustryInfo } from '../models/company-insight.model';

type IndustryInput = string | CompanyInsightApiIndustryInfo;

@Injectable({ providedIn: 'root' })
export class CompanyInsightIndustryDisplayService {
  getVisibleIndustries(industries?: IndustryInput[], maxItems = 5): string[] {
    return this.normalizeIndustries(industries).slice(0, maxItems);
  }

  getHiddenCount(industries?: IndustryInput[], maxItems = 5): number {
    return Math.max(0, this.normalizeIndustries(industries).length - maxItems);
  }

  getHiddenCountMobile(industries?: IndustryInput[]): number {
    return Math.max(0, this.normalizeIndustries(industries).length - 1);
  }

  getHiddenIndustriesTooltipText(industries?: IndustryInput[], startIndex = 5): string {
    return this.normalizeIndustries(industries).slice(startIndex).join(', ');
  }

  getHiddenIndustriesTooltipTextMobile(industries?: IndustryInput[]): string {
    return this.normalizeIndustries(industries).slice(1).join(', ');
  }

  private normalizeIndustries(industries?: IndustryInput[]): string[] {
    return (industries ?? []).map(item =>
      typeof item === 'string' ? item : item.industryName ?? ''
    );
  }
}
